import {Dimensions} from 'react-native';

const DESIGN_WIDTH = 375;
export function designToDp(designSize: number) {
  return (designSize / DESIGN_WIDTH) * Dimensions.get('window').width;
}
